<script lang="ts">
  import '@gouvfr/dsfr/dist/component/link/link.min.css';
  import '@gouvfr/dsfr/dist/component/skiplink/skiplink.min.css';
</script>

<div class="fr-skiplinks">
  <nav
    class="fr-container"
    aria-label="Accès rapide">
    <ul class="fr-skiplinks__list">
      <li>
        <a
          class="fr-link"
          href="#main">
          Contenu
        </a>
      </li>
      <li>
        <a
          class="fr-link"
          href="#footer">
          Pied de page
        </a>
      </li>
    </ul>
  </nav>
</div>
